

import { Route, Routes } from "react-router-dom";
import { ThemeProvider } from "styled-components";
// import Card from "./components/Card/Card";
// import Foot from "./components/Footer/Foot";
// import Form from "./components/Form/Form";
import GlobalStyle from "./components/GlobalStyle";
// import Hero from "./components/Hero/Hero";
import Layout from "./components/Layout";
// import Nav from "./components/Navbar/Nav";
// import Provinsi from "./components/Provinsi/Provinsi";
// import Sum from "./components/Summary/Sum";

// import Two from "./components/Two/Two";
import About from "./pages/component/About";
import Global from "./pages/component/Global";
import Indonesia from "./pages/component/Indonesia";
import Provinces from "./pages/component/Provinces";
import Home from "./pages/Home";
import theme from "./utils/constants/theme";

function App() {
  return (
    <div>
      {/*
       * Render Halaman Home
       * Jika ingin diubah, maka ubah di Halaman Home.
       */}

       {/* membungkus layout yang didalamnya nav + foot */}

    <ThemeProvider theme={theme}>
       <GlobalStyle />
       <Layout>
       <Routes>
          <Route path="/" element={<Home />}/>
          <Route path="/component/global" element={<Global />} />
          <Route path="/component/indonesia" element={<Indonesia />} />
          <Route path="/component/provinces" element={<Provinces />} />
          <Route path="/component/about" element={<About />} />
       </Routes>

      </Layout>
    </ThemeProvider>
    
      
      {/* <Nav /> */}
      {/* <Home /> */}
      {/* <Two /> */}
      {/* <Card /> */}
      {/* <Provinsi />
      <Form />
      <Foot /> */}
     

    </div>
  );
}

export default App;
